<template lang="html">
  <div ref="turnstile"></div>

  <!-- <div
    class="cf-turnstile"
    data-sitekey="1x00000000000000000000AA"
    data-theme="light"
  ></div> -->
</template>
<script>
const turnstileSrc = "https://challenges.cloudflare.com/turnstile/v0/api.js";
const turnstileLoadFunction = "cfTurnstileOnLoad";

// window.turnstile = null;
// window[turnstileLoadFunction] = null;

let turnstileState =
  typeof window !== "undefined"
    ? window.turnstile !== undefined
      ? "ready"
      : "unloaded"
    : "unloaded";

let turnstileLoad = {
  resolve: () => {},
  reject: () => {}
};

export default {
  name: "TurnStile",

  props: {
    siteKey: {
      type: String,
      required: false,
      default: "0x4AAAAAAAVu9VaBC5n7Gk3_"
    },
    resetInterval: {
      type: Number,
      required: false,
      default: 295 * 1000
      // Get a fresh token after reset-interval milliseconds
      // -Turnstile tokens only last for 5 minutes
    },
    size: {
      type: String,
      required: false,
      default: "normal"
      // Widget size  'normal' | 'compact'
    },
    theme: {
      type: String,
      required: false,
      default: "auto"
      // 'light' | 'dark' | 'auto'
    },
    language: {
      type: String,
      required: false,
      default: "auto"
    },
    action: {
      type: String,
      required: false,
      default: ""
      // A customer value that can be used to differentiate widgets under the same sitekey in analytics and which is returned upon validation.
    },
    appearance: {
      type: String,
      required: false,
      default: "always"
      // 'always' | 'execute' | 'interaction-only'
      // Appearance controls when the widget is visible
    },
    renderOnMount: {
      type: Boolean,
      required: false,
      default: true
    },
    resetToken: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      resetTimeout: undefined,
      widgetId: undefined
    };
  },

  computed: {
    turnstileOptions() {
      return {
        sitekey: this.siteKey,
        theme: this.theme,
        language: this.language,
        size: this.size,
        callback: this.callback,
        action: this.action,
        appearance: this.appearance,
        "error-callback": this.errorCallback,
        "unsupported-callback": this.unsupportedCallback
      };
    }
  },
  watch: {
    resetToken: function() {
      // this.reset();
      this.render();
    }
  },

  methods: {
    unsupportedCallback() {
      this.$emit("unsupported");
    },

    errorCallback(code) {
      this.$emit("error", code);
    },

    callback(token) {
      //   console.log(token);
      this.$emit("set-token", token);
      this.startResetTimeout();
    },

    reset() {
      if (window.turnstile) {
        this.$emit("set-token", "");
        window.turnstile.reset();
      }
    },

    remove() {
      if (this.widgetId) {
        window.turnstile.remove(this.widgetId);
        this.widgetId = undefined;
      }
    },

    render() {
      //   console.log(window.turnstile);
      this.widgetId = window.turnstile.render(
        this.$refs.turnstile,
        this.turnstileOptions
      );
    },

    startResetTimeout() {
      this.resetTimeout = setTimeout(() => {
        this.reset();
      }, this.resetInterval);
    }
  },

  async mounted() {
    const that = this;
    const turnstileLoadPromise = new Promise((resolve, reject) => {
      turnstileLoad = { resolve, reject };
      if (turnstileState === "ready") resolve(undefined);
    });

    window[turnstileLoadFunction] = () => {
      turnstileLoad.resolve();
      turnstileState = "ready";
    };

    const ensureTurnstile = () => {
      //   console.log("-------------------------------");
      //   console.log(turnstileState);
      if (turnstileState === "unloaded") {
        turnstileState = "loading";
        const url = `${turnstileSrc}?onload=${turnstileLoadFunction}&render=explicit`;
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = function() {
          // on refresh
          that.render();
        };
        script.addEventListener("error", () => {
          turnstileLoad.reject("Failed to load Turnstile.");
        });
        document.head.appendChild(script);
      }
      return turnstileLoadPromise;
    };

    await ensureTurnstile();

    if (this.renderOnMount) {
      this.render();
    }
  },

  beforeDestroy() {
    this.remove();
    clearTimeout(this.resetTimeout);
  }
};
</script>
<style lang="scss" scoped></style>
